import { QuanLyVanBan, Reception } from 'api';
import { DatePicker, DropDown, Input } from 'components/tt-forms/common';
import { downloadFile } from 'components/utils';
import { LimitFileSize, LimitFileType2 } from 'constants/config';
import { msg } from "constants/message";
import { MasterLayout } from 'layout';
import { Toastr } from 'modules/toastr';
import moment from 'moment';
import React from 'react';
import { Link, browserHistory } from 'react-router';

class ThemMoiVanBan extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataComboboxCoQuanBanHanh: [],
      dataComboboxTheLoaiVanBan: [],
      dataComboboxLinhVucVanBan: [],
      btnSaveLoading: false,
      dataForm: {
        tenVanBan: '',
        coQuanBanHanhId: '',
        linhVucVanBanId: '',
        loaiVanBanId: '',
        soVanBan: '',
        ngayRaVanBan: '',
        documentId: '',
        fileName: '',
      },
      validFile: true,
      isErrorUploadFile: false
    }
  }

  componentDidMount() {
    this.getListLoaiVanBan();
    this.getListCoQuanBanHanh();
    this.getListLinhVucVanBan();
    if (this.props.params.id) {
      this.getDetail(this.props.params.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id != nextProps.params.id && nextProps.params.id) {
      this.getDetail(nextProps.params.id);
    }
  }

  handleBack() {
    browserHistory.goBack();
  }

  checkValidate() {
    let pass = true;
    this.props.validators['danhMuc'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    if (!this.state.dataForm.fileName) {
      pass = false;
      this.setState({
        ...this.state, validFile: false
      });
    }
    return pass;
  }

  handleSave() {
    if (this.checkValidate()) {
      const dataForm = this.state.dataForm;
      const payload = {
        id: this.props.params.id || undefined,
        tenVanBan: dataForm.tenVanBan.trim(),
        coQuanBanHanhId: dataForm.coQuanBanHanhId,
        linhVucVanBanId: dataForm.linhVucVanBanId,
        loaiVanBanId: dataForm.loaiVanBanId,
        soVanBan: dataForm.soVanBan.trim(),
        ngayRaVanBan: moment(dataForm.ngayRaVanBan).add(7, 'hours').toISOString(),
        documentId: dataForm.documentId,
      }
      if (this.props.params.id) {
        QuanLyVanBan.actions.putDanhMucVanBan.request({ id: this.props.params.id }, payload).then(res => {
          Toastr(msg.updateCategorySucess, 'success');
          this.setState({ buttonLoading: false });
          this.handleBack();
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
            this.setState({ buttonLoading: false });
          }
        });
      } else {
        QuanLyVanBan.actions.postDanhMucVanBan.request('', payload).then(res => {
          Toastr(msg.addCategorySucess, 'success');
          this.setState({ buttonLoading: false });
          this.handleBack();
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
            this.setState({ buttonLoading: false });
          }
        });
      }
    }
  }

  getDetail(id) {
    QuanLyVanBan.actions.getChiTietDanhMucVanBan.request({ id: id }).then(res => {
      if (res.data) {
        const data = res.data;
        this.setState({
          ...this.state,
          dataForm: {
            tenVanBan: data.tenVanBan,
            coQuanBanHanhId: data.coQuanBanHanh.id,
            linhVucVanBanId: data.linhVucVanBan.id,
            loaiVanBanId: data.loaiVanBan.id,
            soVanBan: data.soVanBan,
            ngayRaVanBan: data.ngayRaVanBan ? new Date(data.ngayRaVanBan) : '',
            documentId: data.documentMetaData.id,
            fileName: data.documentMetaData.name
          },
        })
      }
    })
  }

  getListLoaiVanBan() {
    QuanLyVanBan.actions.getListLoaiVanBan.request().then(res => {
      if (res.data) {
        this.setState({
          dataComboboxTheLoaiVanBan: res.data
        })
      }
    })
  }

  getListCoQuanBanHanh() {
    QuanLyVanBan.actions.getListCoQuanBanHanh.request().then(res => {
      if (res.data) {
        this.setState({
          dataComboboxCoQuanBanHanh: res.data
        })
      }
    })
  }

  getListLinhVucVanBan() {
    QuanLyVanBan.actions.getListLinhVucVanBan.request().then(res => {
      if (res.data) {
        this.setState({
          dataComboboxLinhVucVanBan: res.data
        })
      }
    })
  }

  onChange(name, e) {
    this.setState({
      dataForm: {
        ...this.state.dataForm,
        [name]: e.target.value
      }
    })
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        dataForm: {
          ...this.state.dataForm,
          [name]: e._d
        }
      });
    } else {
      this.setState({
        dataForm: {
          ...this.state.dataForm,
          [name]: e
        }
      });
    }
  }

  uploadFile(e) {
    if (e.target.files[0]) {
      this.setState({
        ...this.state, validFile: true
      });
      let fileName = e.target.files[0].name;
      let ext = fileName.split('.').pop().toLowerCase();
      let fileSize = e.target.files[0].size;
      if (fileSize > LimitFileSize * 1024 * 1024) {
        Toastr(msg.fileSizeErr, 'warning');
      } else if (!LimitFileType2.includes(ext)) {
        Toastr(msg.fileTypeErr2, 'warning');
      } else {
        let params = { field: 'file', file: e.target.files[0] };

        Reception.actions.postFileUpload.request('', params).then(res => {
          const data = res.data;
          let newState = {
            ...this.state,
            dataForm: {
              ...this.state.dataForm,
              documentId: data.id,
              fileName: data.name,
            },
            isError: false
          };
          this.setState({ ...newState });
        }).catch(error => {
          this.setState({
            isError: true
          });
        });
      }
    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container wrap-block">
          <div className="back-foward">
            <Link onClick={this.handleBack.bind(this)} title="">Về trang trước</Link>
          </div>
          <div className="heading">
            <h2 className="heading-title icon-add">
              {this.props.params.id ? 'Chỉnh sửa văn bản' : 'Thêm mới văn bản'}
            </h2>
          </div>
          <div className="bottom-content">
            <section className='wrap-block'>
              <div className='mt10'>
                <div className='big-border'></div>
              </div>
              <div className='row pl15 pr15'>
                <h2 className='title-14 p20'>1. Thông tin văn bản</h2>
              </div>
              <div className='row pl30 pr30'>
                <div className='row pl30 pr30'>
                  <Input
                    label='Tên văn bản'
                    className='col-25'
                    value={this.state.dataForm.tenVanBan}
                    onChange={this.onChange.bind(this, 'tenVanBan')}
                    name='tenVanBan'
                    require
                    bindValidator={this}
                    channel="danhMuc"
                    placeholder="Nhập tên văn bản"
                    maxLength={128}
                  />
                  <DropDown
                    className="col-25"
                    label="Cơ quan ban hành"
                    options={this.state.dataComboboxCoQuanBanHanh}
                    keyName='giaTri'
                    valueName='ten'
                    placeholder="Chọn"
                    selectedValue={this.state.dataForm.coQuanBanHanhId}
                    onChange={this.onChange.bind(this, 'coQuanBanHanhId')}
                    bindValidator={this}
                    require
                    channel="danhMuc"
                  />
                  <DropDown
                    className="col-25"
                    label="Thể loại văn bản"
                    options={this.state.dataComboboxTheLoaiVanBan}
                    keyName='giaTri'
                    valueName='ten'
                    placeholder="Chọn"
                    selectedValue={this.state.dataForm.loaiVanBanId}
                    onChange={this.onChange.bind(this, 'loaiVanBanId')}
                    bindValidator={this}
                    require
                    channel="danhMuc"
                  />
                  <DropDown
                    className="col-25"
                    label="Lĩnh vực văn bản"
                    options={this.state.dataComboboxLinhVucVanBan}
                    keyName='giaTri'
                    valueName='ten'
                    placeholder="Chọn"
                    selectedValue={this.state.dataForm.linhVucVanBanId}
                    onChange={this.onChange.bind(this, 'linhVucVanBanId')}
                    bindValidator={this}
                    require
                    channel="danhMuc"
                  />
                </div>
                <div className='row pl30 pr30 pb30'>
                  <Input
                    label='Số văn bản'
                    className='col-25'
                    value={this.state.dataForm.soVanBan}
                    onChange={this.onChange.bind(this, 'soVanBan')}
                    name='soVanBan'
                    require
                    bindValidator={this}
                    channel="danhMuc"
                    placeholder="Nhập số văn bản"
                    maxLength={255}
                  />
                  <DatePicker
                    label='Ngày ra văn bản'
                    className='col-25'
                    value={this.state.dataForm.ngayRaVanBan}
                    onChange={this.handleChangeDate.bind(this, 'ngayRaVanBan')}
                    name='ngayRaVanBan'
                    require
                    bindValidator={this}
                    channel="danhMuc"
                    placeholder="Chọn ngày ra văn bản"
                  />
                  <div className='col-100'>
                    <label className="ip-label">
                      Đính kèm văn bản
                      <span className="text-required">*</span>
                    </label>
                  </div>
                  <div className="upload_file_content ml5">
                    <input type="file" className="upload" onChange={this.uploadFile.bind(this)} />
                    <span htmlFor="file" className='mb5'>Tải lên tập tin</span>
                  </div>
                  {
                    !this.state.validFile && <span className='pt-form-helper-text ml5'>{msg.messageDefault}</span>
                  }
                  {
                    this.state.dataForm.fileName && (
                      <Link className="txt-underline txt-blue ml5" onClick={() => { downloadFile(this.state.dataForm.documentId, this.state.dataForm.fileName) }}>{(this.state.dataForm.fileName) ? this.state.dataForm.fileName : ''} </Link>
                    )
                  }
                </div>
              </div>
            </section>
          </div>
          <div className="action-form-wrap pl0 pr0 pt35 pb5">
            <div className="box-bottom">
              <Link className="btn-action btn-close" onClick={this.handleBack.bind(this, false, 'close')}><span>Đóng</span></Link>
              <Link
                className={this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : "btn-action btn-save action-todo"}
                onClick={this.handleSave.bind(this)}
              >
                <span>{this.props.params.id ? 'Cập nhật' : 'Thêm mới'}</span>
              </Link>
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

ThemMoiVanBan.defaultProps = {
  validators: {},
  params: {
    id: ''
  }
}

export default ThemMoiVanBan;



// WEBPACK FOOTER //
// ./src/components/modules/quan-ly-van-ban/ThemMoiVanBan.jsx